// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Home_wrap_XXu6Z","button":"Home_button_1GPy8","link":"Home_link_DobzA"};